<template>
  <div class="register-page">
    <div :class="computedClass">
      <div class="page-title col-xs-12 col-sm-6 pt-2">
        Alertas / {{ title }} ({{ alertsList.length }})
      </div>
    </div>
    <div class="container-dropdown">
      <div class="row">
        <b-dropdown
          :text="!tab1 ? 'EQUIPAMENTOS' : tab1.toUpperCase()"
          class="col-xs-6"
          :variant="!tab1 ? 'outline-3v3' : '3v3'"
          :disabled="showErrorNotSearch || loading"
          size="sm"
        >
          <b-dropdown-item
            v-for="e in equipments"
            :key="e.type"
            @click="
              type = e.type;
              tab1=e.name;
              title= e.name;"
          >
            {{ e.name }}
          </b-dropdown-item>
        </b-dropdown>
        <toolbar
          class="col-xs-12 col-sm-6"
          type="sectors"
          :is-mobile="mobile"
          :is-searching="isSearching"
          @search="searchBy"
          @clear-search="clearSearch"
          :is-admin="isAdmin"
          :selected="selected"
          :number-of-elements="alertsList.length"
          :type-filtering="''"
          ref="INP"
          :is-show="loading"
          :not-exists="showErrorNotFound"
          :not-search="showErrorNotSearch"
        />
      </div>
    </div>
    <div class="register-main">
      <div class="register-buttons">
        <b-button
          v-if="selected.length == 1 &&isAdmin"
          @click="edit"
          pill
          variant="info"
          class="ml-1"
        >
          <pencil-icon title="" />
        </b-button>

        <!-- <b-button
          v-if="isAdmin && type =='dirs'"
          @click="showEmail"
          pill
          :variant="`${dirListEmail.length ? '3v3' : 'danger'}`"
          class="ml-1 p-2"
        >
        <span class="material-icons">
          <img src="../../assets/icons/email_white_24dp.svg">
          </span>
        </b-button> -->

        <b-button
          v-if="selected.length && (isAdmin && type == 'sensors')"
          pill
          variant="danger"
          @click="removeDialog"
          class="ml-1"
        >
          <delete-icon title="" />
        </b-button>

        <b-button
          v-if="isAdmin && type == 'sensors'"
          pill
          variant="3v3"
          @click="add"
          class="ml-1"
        >
          <plus-icon title="" />
        </b-button>
      </div>
      <hr />
      
      <!-- <div class="row" v-if="type == 'dirs' && dirListEmail && !dirListEmail.length">
        <div class="col-12 my-2">
          <strong class="text-danger">
            Atenção!
          </strong>

          Não existem emails cadastrados para receber alertas de dir.
        </div>
      </div> -->
        
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>

        <div
          v-if="showErrorNotFound"
          class="
            EmptyRequest
            w-100
            h-100
            p-0
            row
            center-xs center-md center-sm center-xs0
            mt-3
          "
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há alertas para exibir.</span>
        </div>
        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todos os alertas
            <b-link @click="clearSearch"> clique aqui </b-link>.</span
          >
        </div>
        <div
          v-for="(item, index) in alertsList"
          v-show="!loading"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card eqp-card">
            <div class="header-card">
              <div class="card-name">
                <div class="container-card-header">
                  <div class="header-title">
                    <div v-if="type == 'sensors'" >
                      <div v-if="item.NAME">
                        {{ item.NAME }}
                      </div>
                    </div>
                    <div v-if="type == 'dirs'" >
                      <div v-if="item.DIR_ID">
                        DIR - {{ item.ADDR }}
                      </div>
                    </div>
                  </div>
                </div>
                <bell-icon :title="isBellGreen(item) ? 'Alerta ativo' : 'Alerta inativo'" :class="isBellGreen(item)? 'text-3v3' : 'text-danger'"/>
              </div>
              
            </div>
            <div class="card-details">
              <div v-if="type == 'sensors'">
                
                <div class="py-3">
                  <div v-if="rangesActiveAlerts(item).length">
                    Alertas ativos para:
                    <span v-for="(readType, index) in rangesActiveAlerts(item)" :key="index">
                      <span v-if="index">e</span>

                      <strong>{{capitalizeStr(readType.TYPE_NAME)}}</strong>

                      <span v-if="index == item.RANGES.length - 1">.</span>
                    </span>
                  </div>

                  <div v-else class="text-danger">Alertas de todas as medições estão silenciadas!</div>
                </div>
                  <div>
                </div>
                  <!-- <div>
                    Bateria mínima permitida: 
                    <strong>
                      {{item.BAT_LOW_RANGE}}V
                      .
                    </strong>
                  </div> -->

                  <div v-for="(readType, index) in rangesActiveAlerts(item)" :key="index" class="mb-2">
                      <div>
                        <span>
                          {{capitalizeStr(readType.TYPE_NAME)}} mínima permitida:
                        </span>
                        <strong>
                          {{(findParam('MIN', readType, item) || findParam('MIN', readType, item) === 0) ? `${findParam('MIN', readType, item)} ${readType.UNIT}` : "Indefinido"}}
                        </strong>
                      </div>
                      
                      <div>
                        <span>
                          {{capitalizeStr(readType.TYPE_NAME)}} máxima permitida:
                        </span>
                        <strong>
                          {{(findParam('MAX', readType, item) || findParam('MAX', readType, item) === 0) ? `${findParam('MAX', readType, item)} ${readType.UNIT}` : "Indefinido"}}
                        </strong>
                      </div>
                  </div>

                <div  class="mt-3">
                  <!-- <div v-if="item.EMAIL_ALERT && item.EMAIL_ALERT.length">
                    <div>E-mail(s) selecionado(s):</div>
                    <ul class="pt-0 pb-0 mb-0 mt-0"
                    v-for="(e, index) in item.EMAIL_ALERT" :key="index">
                    <li>{{ e }}</li>
                    </ul>
                  </div>

                  <div v-else class="text-danger">
                    Não existem emails associados a este alerta !
                  </div> -->
                </div>
              </div>
              <div v-if="type == 'dirs'">
                <div class="py-3">
                  Alertas ativos para:
                  <strong>Bateria</strong>
                  e                   
                  <strong>Sinal</strong>
                  .
                </div>

                <div>
                  <div>
                    Bateria mínima permitida: 
                    <strong>
                      {{item.BAT_LOW_RANGE}}V
                      .
                    </strong>
                  </div>

                  <div>
                    Bateria máxima permitida: 
                    <strong>
                      {{item.BAT_HIGH_RANGE}}V                    
                      .
                    </strong>
                  </div>

                  <div>
                    Sinal mínimo permitido: 
                    <strong>
                      {{item.SIGNAL_LOW_RANGE}}%
                      .
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer">
              <b-checkbox
                class="checkbox"
                v-show="isAdmin"
                :value="item"
                v-model="selected"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL DE REMOÇÃO DE EQUIPAMENTOS -->
    <b-modal
      ref="removeEqp"
      centered
      size="sm"
      ok-title="Deletar"
      ok-variant="danger"
      cancel-title="Cancelar"
      content-class="shadow"
      cancel-variant="outline-secondary"
      title="Atenção!"
      @ok="deleteAlert"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          {{
            selected.length == 1
              ? "1 item será apagado"
              : selected.length + " itens serão apagados"
          }}.
        </div>
      </div>
    </b-modal>

    <b-modal
    ref="dirEmail"
    no-close-on-backdrop
    centered
    hide-footer
    body-bg-variant="light"
    title="Altere os e-mails para DIRs:"
    >
    <div class="modal-form pb-3 mr-1">
      <div>
        <b-form-text id="title-email_alert"
        >Adicionar e-mail:</b-form-text
        >
          <b-form-input
          v-model="emailAdd"
          placeholder="Selecione um email..."
          type="email"
          maxlength="40"
          size="sm"
          :state="emailAddstate"
          />
        <b-button
        pill
        variant="3v3"
        class="pt-0 pb-0 my-3"
        size="sm"
        @click="toAddEmail()"
        >
          <plus-icon title="" />
        </b-button>
      </div>
      <div class='pb-3 w-75' v-if="this.arrayEmailsAdd.length > 0">
        <div class="">
          <b-form-text>E-mails para adicionar:</b-form-text>
          <div class="mt-2 ml-2 d-inline-flex" v-for="email of this.arrayEmailsAdd">
            <b-form-input v-model=(email) :readonly="true" />
            <b-button
            class="pt-0 pb-0 mb-0 mt-0 ml-2"
            @click="deleteFromEmail(email)"
            variant="danger"
            >
            <delete-icon title=""/>
          </b-button>
        </div>
        </div>
      </div>
      <div class="d-flex justify-content-center pt-0 pb-0 mb-0 mt-1 w-100"></div>
      <b-form-text>E-mails cadastrados:</b-form-text>
      <div class="mt-2 ml-2 d-inline-flex" v-for="email in dirListEmailCopy">
        <div class="modal-form pt-0 pb-0 mb-0 mt-1 w-100">
          <b-form-input v-model=(email) :readonly="true" />
        </div>
        <b-button
        class="pt-0 pb-0 mb-0 mt-0 ml-2"
        @click="deleteFromCopy(email)"
        variant="danger"
        >
          <delete-icon title=""/>
        </b-button>
      </div>
    </div>
    <b-btn
      block
      variant="3v3"
      size="sm"
      @click="formCorrect"
      >Salvar</b-btn>
    </b-modal>

    <AlertForm
      v-if="type == 'sensors'"
      :show-form="showForm"
      :form-type="formType"
      :sensors="sensors"
      :alerts="alertsList"
      :old-name="
        formType == 'edit' && selected.length ? selected[0].NAME : ''
      "
      :used-names="usedSensorsNames"
      :item-to-edit="selected.length && selected[0]"
      :monitSensors="dataSensors"
      @deleteEmail="deleteEmail"
      @submitRanges="submitRanges"
      @submit="submit"
      @close-form="() => {
        showForm = false;
        formType = '';
      }
      "
    />
    <DirAlertForm
      v-else-if="type == 'dirs'"
      :show-form="showForm"
      :form-type="formType"
      :sensors="sensors"
      :alerts="alertsList"
      :old-name="
        formType == 'edit' && selected.length ? selected[0].NAME : ''
      "
      :item-to-edit="selected.length && selected[0]"
      :monitSensors="dataSensors"
      @deleteEmail="deleteEmail"
      @updateDirs="updateDirs"
      @submitRanges="submitRanges"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />
  </div>
</template>

<script>
import { monit } from "@/api";

import { cookies } from "@/pages/components/cookies";
import { user } from "@/pages/components/globalstore";

import AlertForm from "./components/AlertForm.vue";
import DirAlertForm from './components/DirForm.vue'

//API
import { alerts, dirs } from "../../api";

export default {
  name: "equipments",
  props: {
    local: [String],
    mobile: Boolean,
  },
  components: {
    AlertForm,
    DirAlertForm
  },
  async created() {
    try {
      this.$emit("title-change", "Alertas");
      this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
      await this.getAlerts();
      
    } catch (e) {
      alert("Ocorreu um erro ao solicitar dados de alertas", "e");

    }

  },
  data() {
    return {
      title: "Sensores",
      showForm: false,
      type: "sensors",
      loading: false,
      errorMsg: "Ocorreu um erro. Recarregue a página e tente novamente.",
      ismob: false,
      emptyIcon: require("@/assets/icons/Empty.svg"),
      searchIcon: require("@/assets/icons/search.svg"),
      tab1: "SENSORES",
      tab2: "",
      sensors: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      toDelete: [],
      allSelected: false,
      formType: null,
      alreadyNames: [],
      isAdmin: false,
      equipments: [
        {
          type: "sensors",
          name: "Sensores",
        },
        {
          type: "dirs",
          name: "DIRs",
        },
      ],
      showErrorNotFound: false,
      showErrorNotSearch: false,
      alertsList: [],
      listDIR: [],
      dataSensors:[],
      dirListEmail:[],
      dirListEmailCopy:[],
      emailAdd:'',
      arrayEmailsAdd:[],
      mailbox:require("../../assets/icons/email_white_24dp.svg"),
      arrayEmailDelete:[]
    };
  },
  watch: {
    $route() {
      this.selected = [];
      this.allSelected = false;
      this.type = this.$route.params.type;
    },
    type() {
      this.loading = true;
      this.getAlerts();
    }
  },
  computed: {
    usedSensorsNames() {
      return this.fullList.map(s => s.NAME);
    },
    computedClass() {
      this.ismob = this.mobile;
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    emailAddstate() {
      const emailRegex= new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
      return (
        this.emailAdd !== null && this.emailAdd !== "" && emailRegex.test(this.emailAdd)
      );
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    //título do modal de adição
    selectedEquipment() {
      if (this.type == "sensors") return "sensor";
      else if (this.type == "sensors-model") return "modelo de sensor";
    },
  },
  methods: {
    isBellGreen(item) {
      return !this.isAlertWithoutRangesActive(item);
    },
    findParam(rangeParam, readType, item) {
      if(item && item.RANGES) {
        const valueParam = item.RANGES.find(range => range.POS == readType.POS)[rangeParam];
        console.log({valueParam})
        return valueParam
      }
    },
    isAlertWithoutEmail(item){
      const sensorMissingEmail = this.type == 'sensors' && !(item.EMAIL_ALERT && item.EMAIL_ALERT.length);
      const dirMissingEmail = this.type == 'dirs' && !(this.dirListEmail && this.dirListEmail.length);

      return (sensorMissingEmail) || (dirMissingEmail);
    },
    isAlertWithoutRangesActive(item){
      const sensorMissingActiveRanges = this.type == 'sensors' && !(this.rangesActiveAlerts(item).length);
      const dirMissingActiveRanges = this.type == 'dirs' && false;

      return (sensorMissingActiveRanges) || (dirMissingActiveRanges);
    },
    rangesActiveAlerts(item) {
      if(item && item.RANGES) {
        return item.RANGES
          .filter(r => !!r.IS_RANGE_ACTIVE)

      } else {
        return [];

      }
    },
    capitalizeStr(stringToCapitalize) {
      const loweredString = stringToCapitalize.toLowerCase();

      return loweredString.charAt(0).toUpperCase() + loweredString.slice(1);
    },
    async getAlerts() {
      this.loading = true;
      this.selected=[];
      if(this.type == 'sensors'){
        try {
          let response= await alerts.getAllSensors(user.ID);
          this.alertsList = response.data && response.data;
          this.fullList = this.alertsList.map((e) => e);
          await this.getDirEmails();
          this.loading = false;
          if (
            !this.alertsList.length &&
            this.showErrorNotSearch === false &&
            !this.loading
            ) {
              this.showErrorNotFound = true;
            } else {
              this.showErrorNotFound = false;
            }
            await this.updateAvailableSensors();
        } catch (error) {
          this.loading = false;
          console.error("Falha ao carregar alertas - ", error);
          alert("Ocorreu um erro ao carregar os setores. Recarregue a página.");
        }
      }else if(this.type == 'dirs'){
        try {
          let response= await alerts.getAllDirs(user.ID);
          this.alertsList = response.data && response.data;
          this.dirEmails
          this.fullList = this.alertsList.map((e) => e);
          this.loading = false;

          if (
            !this.alertsList.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        } catch (error) {
          this.loading = false;
          console.error("Falha ao carregar alertas - ", error);
          alert("Ocorreu um erro ao carregar os setores. Recarregue a página.");
        }
      }
    },
    async resetPage() {
      this.selected = [];

      await this.getAlerts();

      this.updateAvailableSensors();
    },
    async getDirEmails(){
     try {
       const { data } = await alerts.getDirsEmails(user.ID);
       const alertsEmails = data.map(item=> item.EMAIL_ALERT);
       
       this.dirListEmail = alertsEmails ? alertsEmails : [];

      } catch(e) {
        console.error(e);

     }
    },
    async showEmail(){
      await this.getDirEmails();
      this.dirListEmailCopy=[...this.dirListEmail]
      this.$refs.dirEmail.show();
      this.arrayEmailsAdd=[];
    },
    async formCorrect(){
      try {
        this.$refs.dirEmail.hide();
        if(this.arrayEmailsAdd && this.arrayEmailsAdd.length) {
          await alerts.addDirEmail(user.ID,
            {
              data:this.arrayEmailsAdd
            });
        }

        if(this.arrayEmailDelete && this.arrayEmailDelete.length) {
          await alerts.deleteDirEmail(user.ID,
            {
              data:this.arrayEmailDelete
            })
        }

        this.arrayEmailsAdd=[];
        this.arrayEmailDelete=[];

        await this.getDirEmails();
        alert("Sucesso ao salvar as mudanças de email", "s");
      
      } catch(e) {
        alert("Ocorreu um erro ao salvar as mudanças de email", "e");

      }
    },
    async deleteAlert() {
      try {
         alert("Sucesso ao deletar alerta", "s");
        for (let select of this.selected) {
          this.toDelete.push(select.ID_ALERT);
        };
  
        await alerts.deleteSensor(
          user.ID,
          {
            IDS:this.toDelete
          }
          );
  
        this.toDelete.length = 0;
  
        await this.resetPage();
      
      } catch(e) {
        alert("Ocorreu um erro ao deletar alerta", "e");

      }
    },
    async submit(data) {
      const actionAlert = this.formType == "add" ? 'salvar' : 'atualizar';

      try {
        if (this.formType == "add") {
          if (!this.alertsList.find((item) => {
            return item.SENSOR_ID == data.SENSOR_ID;
          })) {
            await alerts.addSensor(
              user.ID,
              {
                SENSOR_ID:(data.SENSOR_ID),
                TOLERANCE_LOW:(data.TOLERANCE_LOW),
                TOLERANCE_HIGH:(data.TOLERANCE_HIGH),
                TIME_TO_RESEND_LOW:(data.TIME_TO_RESEND_LOW),
                TIME_TO_RESEND_HIGH:(data.TIME_TO_RESEND_HIGH),
                EMAIL_ALERT:[(data.EMAIL_ALERT)],
                RANGES:data.RANGES,
                USER_ID: user.ID
              })
            await this.resetPage();
          }
        }
        else {
          await alerts.updateSensor(
              user.ID,
              {
                data
              }
          );
  
          data.length = 0;
  
          await this.resetPage();
        }

        alert(`Sucesso ao ${actionAlert} alerta`, "s");
      
      } catch(e) {
        alert(`Ocorreu um erro ao ${actionAlert} alerta`, "e");

      }
    },
    async submitRanges(updateRanges){
      try {
        let response = await alerts.updateSensorRanges(
          user.ID,
          {
            data:updateRanges
          }
        );
        updateRanges.length=0;

        alert("Parâmetros de medições atualizados com sucesso", "s");

      } catch(e) {
        alert("Erro ao atualizar parâmetros de medições", "e");

      }
    },
    async deleteEmail(data){
      try {
        let response = await alerts.updateSensorRanges(
          user.ID,
          {
            data
          }
        );
        await this.resetPage();
        alter("Sucesso ao deletar emails", "s")

      } catch(e) {
        
        alter("Falha ao deletar emails", "e")
      }
    },
    async updateAvailableSensors() {
      this.sensors.length = 0;
      const controller = new AbortController();
      const sensorsfarm = await monit.sensor(controller);
      const data = await sensorsfarm.json();
      this.dataSensors = data;

      // PEGAR O NOME DOS SENSORES
      this.alertsList.map(itemAlert=> {
       let aux = data.find(item => (item.ID == itemAlert.SENSOR_ID) && (item.FOLDER === 'sns')) 
       if(aux){
        itemAlert["NAME"] = aux.NAME
       }
      });
      //

      data.map((item) => {
        let aux = this.alertsList.find(
          (itemAlert) => itemAlert.SENSOR_ID == item.ID
        );
        if (aux == undefined) {
          return this.sensors.push({ value: item.ID, text: item.NAME });
        }

      });
    },
    async updateDirs(data){
      try {

        await alerts.updateAlertDirs(
          user.ID,
              {
                data
              }
          );
          

          const dir = this.alertsList.find(dir => dir.ID_ALERT_DIR == data[0].id_alert_dir);
          alert(`Sucesso ao atualizar alerta dor DIR ${dir.DIR_ID}`, "s")
  
          data.length = 0;
          await this.resetPage();

      } catch(e) {
        const dir = this.alertsList.find(dir => dir.ID_ALERT_DIR == data[0].id_alert_dir);
        
        if(dir) {
          alert(`Falha ao atualizar alerta dor DIR ${dir.DIR_ID}`, "e");

        } else {
          alert(`Falha ao editar alerta`, "e");

        }
        

      }
    },
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.alertsList.length)
        this.selected = this.alertsList.slice();
      else if (this.selected.length == this.alertsList.length)
        this.selected = [];
    },

    //excluir itens da lista de selecionados
    makeAlert(ret) {
      if (ret) alert(ret.log, ret.alert);
      else alert(this.errorMsg);
    },
    removeDialog() {
      this.$refs.removeEqp.show();
    },

    //pré-definição dos campos na área de edição
    edit() {
      this.formType = "edit";
      this.showForm = true;
    },
    add() {
      this.formType = "add";
      this.showForm = true;
    },
    searchBy(name) {
      this.selected = [];
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.alertsList = this.fullList.filter((item) => {
          if (item.SENSOR_NAME && item.SENSOR_NAME.indexOf(this.filter) > -1) {
            return true;
          }
        });
        if (this.alertsList.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.alertsList = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.alertsList = this.fullList.map((e) => e);
      this.$refs.INP.clearText();
    },
    toAddEmail(){
      this.arrayEmailsAdd.push(this.emailAdd);
      this.emailAdd='';
    },
    deleteFromEmail(email){
      let index = this.arrayEmailsAdd.indexOf(email);
      this.arrayEmailsAdd.splice(index,1);
    },
    deleteFromCopy(email){
      this.arrayEmailDelete.push(email);
      let index = this.dirListEmailCopy.indexOf(email);
      this.dirListEmailCopy.splice(index,1);
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 5px;
}
.card-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-name .material-design-icon {
  font-size: 1.3em;
  color: var(--green-3v3);
  align-self: flex-start;
}
.eqp-card {
  padding-bottom: 55px !important;
  max-height: 235px;
  min-height: 230px;
}
.header-maker,
.header-model {
  color: #e07f52;
  font-size: 0.88em;
}
.container-card-header {
  width: 88%;
}
.header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
  /* max-width: 177px; */
}
h5 {
  word-break: break-all;
  color: var(--text-gray-primary);
  font-weight: 600;
}
.card-details {
  padding-top: 3px;
  height: 143px;
  overflow-y: auto;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  text-overflow: ellipsis;
  line-height: 1.3em;
}
.card-details strong {
  color: var(--text-gray-primary);
}
.scrollable {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}
.header {
  flex-basis: 34px;
}
.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  min-height: 1.5em;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}
.show-details-cards a:hover {
  background: #f5f5f5;
}
.register-page-warning {
  overflow-y: auto;
  overflow-x: hidden;
  height: 95.8%;
}
.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-mobile {
  min-height: 29px;
}
@media screen and (max-width: 767px) {
  .header-card {
    min-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ececec;
  }
  .header {
    min-height: 90px;
  }
}
@media screen and (max-width: 676px) {
  .eqp-card {
    padding-bottom: 45px !important;
  }
}
</style>
